import { map } from "lodash";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import Components from "./Components";
import { isFieldFormLoading } from "@/utils/formHelper";
import { useLogin } from "@/hooks/auth";

export const FormFields = ({
  fields,
  methods,
  isLoading,
  isDisabled,
  isAuth,
}: {
  fields: any;
  methods: UseFormReturn;
  isLoading: boolean | string[];
  isDisabled?: boolean;
  isAuth: boolean;
}) => {
  const { isUserLoggedIn } = useLogin();
  return (
    <React.Fragment>
      {map(fields, (item, i) => {
        // Skip auth-only fields when user is not logged in (ex: Templates)
        if (item.auth && !isUserLoggedIn()) {
          return <React.Fragment key={i} />;
        }
        const Component = Components[item["component"]];
        const itemFields = {
          formfields: item.formFields,
          ...item,
        };
        delete itemFields.formFields;

        if (!item.name) {
          if (item.formFields) {
            return (
              <Component
                key={i}
                {...itemFields}
                data-qa={item.data_qa ?? item.dataQA}
                dataTestId={item.data_testid ?? item.dataTestId}
                defaultValue={item.defaultValue}
                id={item.id}
                formFields={item.formFields}
                dataQA={item.dataQA ?? item.data_qa}
              >
                <FormFields
                  fields={item.formFields}
                  methods={methods}
                  isLoading={isLoading}
                  isDisabled={isDisabled}
                  isAuth={isAuth}
                />
              </Component>
            );
          } else {
            return (
              <Component
                key={i}
                {...itemFields}
                dataQA={item.dataQA ?? item.data_qa}
                dataTestId={item.data_testid ?? item.dataTestId}
                defaultValue={item.defaultValue}
                id={item.id}
              >
                {item.children}
              </Component>
            );
          }
        }

        const errors = methods.formState.errors;
        const isFieldLoading = isFieldFormLoading(item.name, isLoading);
        const fieldState = methods.getFieldState(item.name);

        return (
          <Component
            {...itemFields}
            key={i}
            dataQA={item.dataQA ?? item.data_qa}
            dataTestId={item.data_testid ?? item.dataTestId}
            error={errors[item.name]}
            disabled={isFieldLoading || isDisabled || itemFields.disabled}
            icon={isFieldLoading}
            errorMessage={errors[item.name]?.message}
            success={fieldState?.isTouched && !fieldState?.error}
            defaultValue={item.defaultValue}
            formFields={item.formFields}
            loading={item.component !== "ButtonLib" ? isFieldLoading : undefined}
            isLoading={item.component === "ButtonLib" ? isFieldLoading : undefined}
          />
        );
      })}
    </React.Fragment>
  );
};
